module.exports = __webpack_public_path__ + "media/images/fdic-5ec7d9e0a6b2371ef72f751ee6bcd5fc.png";